module.exports = __webpack_public_path__ + "media/images/flags/16/Germany-99d37571aa9a808a7f87d28b6adf5720.png";